import { useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import { DOCUMENTS_QUERY } from "./useDocuments";

const CREATE_DOCUMENT_MUTATION = gql`
  mutation CreateDocument(
    $projectId: ID!
    $attachment: Upload!
    $title: String
    $description: String
    $documentType: DocumentTypeEnum
  ) {
    createDocument(
      projectId: $projectId
      attachment: $attachment
      title: $title
      description: $description
      documentType: $documentType
    ) {
      document {
        id
        title
        filename
        documentType
      }
    }
  }
`;

export interface CreateDocumentInput {
  projectId: string;
  attachment: File;
  title?: string | null;
  description?: string | null;
  documentType?: string | null;
}

export function useCreateDocument(projectId: string) {
  const [createMutation, { loading, error }] = useMutation(
    CREATE_DOCUMENT_MUTATION,
    {
      refetchQueries: [{ query: DOCUMENTS_QUERY, variables: { projectId } }],
    }
  );

  const createDocument = async (input: CreateDocumentInput) => {
    const documentType =
      input.documentType != null
        ? (input.documentType.toUpperCase() as "IMAGE" | "DOCUMENT" | "PROJECT")
        : null;
    const { data } = await createMutation({
      variables: {
        projectId: input.projectId,
        attachment: input.attachment,
        title: input.title ?? null,
        description: input.description ?? null,
        documentType,
      },
    });
    return (data as { createDocument: { document: { id: string } } })
      .createDocument.document;
  };

  return { createDocument, loading, error };
}
